import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Documents" }
const _hoisted_2 = { class: "Documents__filter" }
const _hoisted_3 = { class: "Documents__list" }

import { computed } from "vue";
import { useDocumentsStore } from "@/stores/documents";
import { Document } from "@/types";
import { documentToSlug } from "@/tools/document";
import { useRouter } from "vue-router";
import DocumentCard from "@/components/pages/documents/card/DocumentCard.vue";
import DocumentsFilter from "@/components/pages/documents/DocumentsFilter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const documentsStore = useDocumentsStore();

const list = computed(() => {
    return documentsStore.sorted;
});

const selectDocument = (document: Document) => {
    const slug = documentToSlug(document);
    const prefix = document.doctype;
    router.push({ name: "Document", params: { slug, prefix } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DocumentsFilter)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (document) => {
          return (_openBlock(), _createElementBlock("li", {
            key: document.id
          }, [
            _createVNode(DocumentCard, {
              document: document,
              onClick: ($event: any) => (selectDocument(document))
            }, null, 8, ["document", "onClick"])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})